.av-card-conversation {
  &.av-card-conversation-secondary {
    .av-card.av-card-bottom {
      margin-bottom: calc($container-height + 10px);
    }
  }
  &.av-card-conversation-secondary {
    .av-card.av-card-top {
      margin-top: calc($container-height + 10px);
    }
  }
  &.av-card-conversation-minimized {
    div.av-card {
      .av-card-body,
      .av-card-footer {
        display: none;
      }
    }
  }
  &.av-card-conversation-mobile {
    .av-card-editor {
      input {
        font-size: 16px;
      }
    }
    .av-card.av-card-blur:not(.av-card-top) {
      bottom: 0px;
      &.av-card-left {
        left: 100px;
      }
      &.av-card-right {
        right: 100px;
      }
    }
    .av-card.av-card-blur.av-card-top {
      bottom: auto;
      top: -75px;
      &.av-card-right {
        right: 100px;
      }
      &.av-card-left {
        left: 100px;
      }
    }
    &.av-card-conversation-minimized {
      .av-card.av-card-blur:not(.av-card-top) {
        bottom: 34px;
      }
      .av-card.av-card-blur.av-card-top {
        top: -40px;
      }
    }
  }
  div.av-card {
    border: 0;
    .av-card-body {
      height: min(300px, calc(100vh - 200px));
      overflow: auto;
      padding: 10px;
    }
  }
}

av-asset {
  height: 100%;
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.av-card-footer {
  box-shadow: 0 -3px 5px -5px fade-out($color: black, $amount: 0.8);
  background: var(--av-card-background-color);
}

.av-attachment-container {
  flex-direction: row;
  display: flex;
  align-items: center;
}

.av-attachment-action {
  padding: 5px;
}

.av-attachment-list {
  flex-direction: row;
  display: flex;
  padding: 5px;
  overflow-x: auto;
  width: 100%;
}

.av-attachment {
  // box-shadow: 0 0 10px 1px fade-out($color: black, $aemount: 0.8);
  padding: 5px;
  border: 1px solid var(--av-color-gray);
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 10px;
  .av-attachment-name {
    max-width: 170px;
    overflow: hidden;
    font-size: 0.9em;
    margin-right: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

// av-card-header{
//   direction: var(--av-direction);
// }

.av-card-editor {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  direction: var(--av-direction);
  form {
    width: 100%;
  }
  input {
    border: 0;
    padding: 15px;
    width: 100%;
    box-sizing: border-box;
    color: var(--av-card-color);
    background-color: transparent;
    font-size: 1em;
    direction: var(--av-direction);
    border-radius: var(--av-border-radius-container);
    &::placeholder {
      opacity: 0.7;
      color: var(--av-card-color);
    }
    &:focus-visible {
      outline-color: var(--av-color-focus-outline);
      outline-offset: -4px;
    }
  }
}

.av-chat-row {
  padding: 2px;
  margin-top: 6px;
  &.av-chat-row-local {
    text-align: right;
    .av-chat-message:not(.av-chat-message-error) {
      background: var(--av-chat-bubble-background-color);
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 8px;
      color: var(--av-chat-bubble-color);
      .av-chat-message-link,
      .av-chat-message-file-download {
        color: var(--av-chat-bubble-color);
      }
    }
  }
}

.av-chat-message-bot {
  display: flex;
  flex-direction: column;
  gap: 8px;

  av-button {
    min-height: 27.5px;
  }
}

.av-chat-message-bot-replies {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.av-chat-row-error {
  text-align: center;
  color: var(--av-color-danger);
  font-weight: bold;
}

.av-chat-message {
  box-sizing: border-box;
  max-width: 80%;
  padding: 5px 10px;
  border-radius: 8px 8px 8px 0;
  display: inline-block;
  background: var(--av-color-gray-light);
  color: var(--av-font-color-dark);
  white-space: pre-wrap;
  word-break: break-word;

  p {
    margin: 0;
    padding: 0;
    display: inline;
  }
  ul {
    margin: 0;
    padding-left: 12px;
    // display: inline-flex;
    // flex-direction: column;
    padding-bottom: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    // display: inline;
    margin: 0;
  }

  pre {
    border: 1px solid;
    border-radius: 4px;
    padding: 9px;
    white-space: pre-wrap;
    margin: 0;
    display: inline-block;
  }

  table {
    float: left;
  }
}

.av-chat-message-file {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  label {
    font-weight: bold;
    font-size: 0.9em;
    margin-right: 10px;
    width: 100%;
    /*
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    */
  }
  .av-chat-message-file-state {
    width: 28px;
    height: 28px;
    position: relative;
    av-spinner {
      transform: scale(0.3);
      position: absolute;
      top: -26px;
      left: -26px;
    }
  }
}

.av-chat-message-pending {
  opacity: 0.5;
}

.av-chat-message-error {
  background-color: transparent;
  color: var(--av-color-danger);
}

.av-typing-loader,
.av-typing-loader:before,
.av-typing-loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.av-typing-loader {
  color: var(--av-font-color-dark);
  font-size: 5.2px;
  margin: 2px 5px;
  top: -6px;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
  transform: scale(0.5);
}
.av-typing-loader:before,
.av-typing-loader:after {
  content: "";
  position: absolute;
  top: 0;
}
.av-typing-loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.av-typing-loader:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

.av-card-editor-tools {
  padding-right: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.av-card-editor-tool {
  display: flex;
  font-size: var(--av-font-size);
  width: 2.6667em; // 40px;
  height: 2.6667em; // 40px;
  padding: 0 5px; // 8px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 0;
  background-color: transparent; // var(--av-color-accent);
  border-radius: var(--av-border-radius-button); //50%;

  av-asset {
    opacity: 0.88;
    transition: opacity 0.2s ease-out;
  }
  &:hover av-asset {
    opacity: 1;
    cursor: pointer;
  }
  &:focus-visible {
    outline-color: var(--av-color-focus-outline);
  }
}

.av-card-editor-tool-attach {
  position: relative;
  overflow: hidden;
  input[type="file"] {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 1;
    &:hover + av-asset {
      opacity: 1;
    }
  }
  img,
  av-asset {
    cursor: pointer;
    width: 22px !important;
  }
}

.status-error {
  background-color: var(--av-color-danger);
  color: var(--av-color-danger-contrast);
  font-size: 1.1em;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.av-agent-container {
  position: relative;
  padding: 0 8px;
  .av-notifications {
    position: absolute;
    top: -8px;
    left: 24px;
    background: var(--av-color-danger);
    font-size: 12px;
    font-weight: bold;
    color: var(--av-color-danger-contrast);
    width: 16px;
    height: 16px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
  }
}

.av-chat-message-hint {
  font-size: 11.5px;
  opacity: 0.5;
  padding-top: 4px;
}

.av-card-editor form {
  display: flex;
  align-items: center;
}

.av-card-conversation-header-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.av-chat-row-notice {
  padding: 0;
  margin-top: 0;
}

.av-chat-notice {
  padding: 2px 2px 0 2px;
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.8;
  // text-align: center;
  & + .av-chat-message-hint {
    // text-align: center;
    padding: 4px 2px 2px 2px;
  }
}
